module.exports = __webpack_public_path__ + "static/media/high-right-3.d79ae7ef.png";